module.exports = __webpack_public_path__ + "static/media/arrival-icon.59e44835.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/arrival-icon.svg
// module id = 792
// module chunks = 0